<template>
  <b-card-code
    title="افزودن دستگاه ردیاب جدید"
  >
    <b-form @submit.prevent>
      <b-row>

        <!-- title -->
        <b-col cols="6">
          <b-form-group
            label="imei"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-imei"
                v-model="device.imei"
                placeholder=""
                required
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- پروتکل -->
        <b-col cols="6">
          <b-form-group
            label="مدل"
            label-for="vi-protocol"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                  required
                v-model="device.modelId"
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in options"
                  :value="item._id"
                >
                  {{ item.title }} - {{ item.protocol }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- port -->
        <b-col cols="6">
          <b-form-group
            label="نمایندگی"
            label-for="vi-agent"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.resellerId"
                required
              >
                <option
                    selected
                    disabled
                    value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in agentList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- port -->
        <b-col cols="6">
          <b-form-group
            label="سرور"
            label-for="vi-server"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.serverId"
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in serverList"
                  :value="item._id"
                  required
                >
                  {{ item.title }} {{ item.url }}:{{ item.port }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- disabled -->
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              id="disabled"
              v-model="device.disabled"
              name="disabled"
              value="true"
            >
              Disabled
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submitForm()"
          >
            ذخیره
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            class="mr-1"
            variant="outline-secondary"
          >
            از نو
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            class="mr-1"
            variant="outline-primary"
            @click.prevent="onCancel"
          >
            لغو
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend, BFormCheckbox, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import ModelService from '@/services/model.service'
import DeviceService from '@/services/device.service'
import router from '@/router'
import Model from '@/models/model'
import Device from '@/models/device'
import customerService from '@/services/customer.service'
import ServerService from '@/services/server.service'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BFormCheckbox,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      model: new Model('', '', '', ''),
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      options: [],
      agentList: [],
      serverList: [],
    }
  },
  async mounted() {
    try {
      ModelService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.options = res.result.data
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }

    try {
      this.agentList = []
      await customerService.getAll({ type: 1 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.agentList.push(res.result.data[0])
            }
          }
        },
      )
      await customerService.getAll({ type: 2 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.agentList.push(res.result.data[0])
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
    try {
      ServerService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.serverList = res.result.data
            } else {
              this.serverList = []
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
  },
  created() {
    if ('id' in this.$route.params) {
      this.getContactById()
    } else {
      this.$router.push({ name: 'admin-device-all' })
    }
  },
  methods: {
    getContactById() {
      DeviceService.getById({ id: this.$route.params.id }).then(
        res => {
          if (res.status === 'success') {
            this.device = res.result.data
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    async submitForm() {
      this.device.disabled = this.disabled === 'true'
      DeviceService.add(this.device).then(
        res => {
          if (res.status === 'success') {
            router.push({ name: 'admin-device-all' })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'admin-device-all' })
    },
  },
}
</script>
